import { Component, OnInit } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';
import { PartnerFinanceReportsComponent } from '../partner-finance-reports/partner-finance-reports.component';
import { AppPrimengModule } from 'app/app-primeng-module';
import { AppComponent } from 'app/app.component';

export enum PartnerFinanceMenuEnum {
    Transactions = 1,
    Payouts = 2
}

@Component({
    selector: 'partner-finance-root',
    standalone: false,
    templateUrl: './partner-finance-root.component.html',
    styleUrls: ['./partner-finance-root.component.scss',
        '../../../../../styles/m3-defaul-material-theme.scss',
        '../../../../../styles/onboardingslidermenu.scss']
})
export class PartnerFinanceRootComponent implements OnInit {

    constructor(public app: AppComponent ) { }


    ngOnInit(): void {
    }
}
